export default __webpack_public_path__ + "static/howdy-f8e96bb15694ee51df5dfa23b26b6d9b.png";